<script>
export default {
  inject: ['$validator'],
  props: {
    name: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    validation: {
      type: String,
      default: null,
    },
    actions: {
      type: Array,
      default() {
        return [];
      },
    },
    info: {
      type: String,
      default: null,
    },
    format: {
      type: Function,
      default(val) {
        return val;
      },
    },
  },
  data() {
    return {
      mutableValue: this.value,
    };
  },
  watch: {
    errors() {
      if (this.errors().any()) {
        this.$emit('errorsUpdated', this.errors().errors);
      }
    },
  },
  methods: {
    formatLabel() {
      const app = this;
      return app.label || app.name.replace('_', ' ').toLowerCase()
        .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
    },
  },
};
</script>
